import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Modal from '../../modal/Modal';
import PrimaryButton from '../../buttons//PrimaryButton.tsx';
import { toggleInspiredAction } from '../../../redux/actions/projectConfig';
import { getProjectConfig } from '../../../redux/selectors/projectConfig';
import { postTeamChartInspiredUsingTeamidAndChartid } from '../../../api/cloudApiGenerated';
import { getChartConfig } from '../../../pages/ChartEditorPage/selectors/chartEditor';
import { getProfileConfig } from '../../../redux/selectors/profile';
import { snackBar } from 'highed';
import { ButtonColor } from 'shared/buttons/models/ButtonModels';

export default function InspiredModal() {
  const dispatch = useDispatch();
  const { toggleInspired } = useSelector(getProjectConfig);
  const { chartId } = useSelector(getChartConfig);
  const { team } = useSelector(getProfileConfig);

  const toggleInspiredModal = () => {
    dispatch(toggleInspiredAction(false));
  };

  const share = async () => {
    await postTeamChartInspiredUsingTeamidAndChartid(team.id, chartId);
    snackBar('Project submitted');
    toggleInspiredModal();
  };

  return (
    <Modal
      isOpen={toggleInspired}
      onClose={toggleInspiredModal}
      title={'Share your project to everviz inspired'}
      width={'w-4/12 max-w-xl'}
      bg={'bg-ev-yellow-1'}
    >
      <p className="font-medium pb-6 m-0">
        Get more exposure on your work and inspire others. <br />
        Share your project with our community on&nbsp;
        <a className="whitespace-nowrap	" href="https://www.everviz.com/inspired" target="_blank" rel="noreferrer">
          everviz.com/inspired. <i className="fas fa-external-link" />{' '}
        </a>
      </p>

      <div className="flex gap-2">
        <PrimaryButton onClick={share} text={'Share my project'} />
        <PrimaryButton onClick={toggleInspiredModal} text="Cancel" buttonColor={ButtonColor.BabyBlue} />
      </div>
    </Modal>
  );
}
